import { render, staticRenderFns } from "./news_course_list.vue?vue&type=template&id=e5c6b76a&scoped=true&"
import script from "./news_course_list.vue?vue&type=script&lang=js&"
export * from "./news_course_list.vue?vue&type=script&lang=js&"
import style0 from "./news_course_list.vue?vue&type=style&index=0&id=e5c6b76a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c6b76a",
  null
  
)

export default component.exports